import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const generalPersonalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings-general',
	path: '/jira/settings/personal/general',
};
